'use client'

import { useEffect, useRef } from 'react'
import { useSegmentAnalytics } from './Provider'

export const PageViewed = ({ children, pageName }: { children: React.ReactNode; pageName: string }) => {
  const analytics = useSegmentAnalytics()
  const emitted = useRef(false)

  useEffect(() => {
    if (emitted.current) return

    emitted.current = true

    analytics.page(pageName)
  }, [analytics, pageName])

  return <>{children}</>
}
